// Version : 0.0.1
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import ActiveMemberActionTypes from './active-member.types';
import { ActiveMemberListGet } from './active-member.service';
import {
	getActiveMemberDetailsSuccess,
	getActiveMemberDetailsFailure,
	getActiveMemberDetailsResponseChanged,
} from './active-member.action';
import { encryptData } from '../../_common/enode-decode';

/** *********************  START GET PROGRESS REPORT DETAILS  ******************** */
export function* getActiveMemberList({ payload }: any) {
	try {
		const {
			companyID,
			branchID,
			centerID,
			groupID,
			funderID,
			databaseName,
			fromDate,
			toDate,
			tillDate,
			isThriftActive,
			searchType,
			userLevel,
			userRole,
			userID,
		} = payload;
		const key = 'GetActiveMemberReportKey';
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			FunderID: funderID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			TillDate: tillDate,
			IsThriftActive: isThriftActive,
			SearchType: searchType,
			UserLevel: userLevel,
			UserRole: userRole,
			UserID: userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(ActiveMemberListGet, encodeData);
		if (responseData.data.status === '100') {
			yield put(getActiveMemberDetailsFailure(responseData.data));
		} else {
			yield put(getActiveMemberDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getActiveMemberDetailsFailure(error));
	}
}

export function* resetGetActiveMemberListResponse() {
	yield put(getActiveMemberDetailsResponseChanged());
}

export function* onGetActiveMemberListDetails() {
	yield takeLatest(ActiveMemberActionTypes.GET_ACTIVE_MEMBER_LIST_START, getActiveMemberList);
}

export function* onGetActiveMemberListResponseReset() {
	yield takeLatest(
		ActiveMemberActionTypes.GET_ACTIVE_MEMBER_LIST_RESPONSE_RESET,
		resetGetActiveMemberListResponse,
	);
}
/** *********************  END GET PROGRESS REPORT LIST ******************** */

export function* reportActiveMemberSaga() {
	yield all([call(onGetActiveMemberListDetails), call(onGetActiveMemberListResponseReset)]);
}
